import { LasctActiveRoute } from "@edp-models/layout.model";
import { Menu } from "@edp-models/menu.model";

export interface ILayoutState {
    showSidebar: boolean;
    selectOverlay: {
        type: string,
        origin?: string
    };
    selectSidebarSublevel: Menu[];
    activeItemSidebar: string;
    loaderCount: number;
    lastActiveRoute: LasctActiveRoute;
    mainMenu: Menu[];
    tabMenu: string;
    lastResponse: boolean;
    needLoadUserPoints: boolean;
    showAlert: boolean;
    openSublevel: boolean;
}

export const initialLayoutState: ILayoutState = {
    showSidebar: false,
    selectOverlay: {
        type: null,
        origin: null
    },
    selectSidebarSublevel: [],
    activeItemSidebar: null,
    loaderCount: 1,
    lastActiveRoute: null,
    mainMenu: [],
    tabMenu: null,
    lastResponse: false,
    needLoadUserPoints: false,
    showAlert: false,
    openSublevel: false,
};
